
































































// Importing components
import BaseButton from '@/ui/BaseButton.vue';
import BaseLoadingAnimation from '@/ui/BaseLoadingAnimation.vue';
import TheVariationsFields from '@/components/products/TheVariationsFields.vue';
import TheAddonsFields from '@/components/products/TheAddonsFields.vue';
import BaseInputField from '@/ui/BaseInputField.vue';
// Importing variables
import {TagsProduct} from '@/ts/variables';


export default {
    name: 'TheFormProducts2',
    components: {
        BaseButton,
        BaseLoadingAnimation,
        BaseInputField,
        TheAddonsFields,
        TheVariationsFields,
    },
    props: {
        product: Object,
        errors: Array,
    },
    data() {
        return {
            tags: Array(),
            temp: Object,
        };
    },
    methods: {
        addAddon(event) {
            this.product.addons.push(event);
        },
        addVariation(event) {
            this.product.variations.created.push(event);
        },
        deleteAddon(index) {
            this.product.addons.splice(index, 1);
        },
        deleteVariation(index, type) {
            if (this.product.variations[type][index].hasOwnProperty('id')) {
                this.product.variations.deleted.push(this.product.variations[type][index].id);
            }
            this.product.variations[type].splice(index, 1);
        },
        onShow(index) {
            // TODO: Fix this
            document.getElementById('icon_' + index).style.display = 'none';
            document.getElementById('options_' + index).style.display = 'block';
        },
        onHide(index) {
            document.getElementById('icon_' + index).style.display = 'block';
            document.getElementById('options_' + index).style.display = 'none';
        },
    },
    computed: {
        categories() {
            return this.$store.getters.response.map((item) => {
                return {
                    text: item.attributes.name,
                    value: item.id,
                };
            });
        },
    },
    created() {
        this.tags = TagsProduct;
        this.temp = {
            name: '',
            is_optional: '',
        };
    },
};
